import axios from "axios";

const urls = process.env.REACT_APP_BASE_URL;

//**마이페이지 진입시 패스워드 체크**
export const requestCheckPassword = (params) =>
  axios
    .post(`${urls}/mu/user/password`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//1:1 문의하기 등록
export const requestInquiryAdd = (params) =>
  axios
    .post(`${urls}/mu/user/qna/new`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//1:1 문의내역
export const requestInquiryList = (params) =>
  axios
    .post(`${urls}/mu/user/qna/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//유저 조회
export const requestUserLookup = (params) =>
  axios
    .post(`${urls}/mu/user/lookup`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//비밀번호 변경
export const requestChangeUserPassword = (params) =>
  axios
    .post(`${urls}/mu/user/password/change`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//이메일 변경(요청)
export const requestChangeUserEmail = (params) =>
  axios
    .post(`${urls}/mu/user/mail/change`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//이름 변경
export const requestChangeUserName = (params) =>
  axios
    .post(`${urls}/mu/user/name/change`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//핸드폰번호 변경
export const requestChangeUserPhone = (params) =>
  axios
    .post(`${urls}/mu/user/phone/change`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//나의 포인트 거래내역
export const requestMyPointHistory = (params) =>
  axios
    .post(`${urls}/mu/user/point/history`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//나의 소멸예정 포인트
export const requestMyExpirationPoint = (params) =>
  axios
    .post(`${urls}/mu/user/point/expiration`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//회원 설정 조회
export const requestUserSetting = (params) =>
  axios
    .post(`${urls}/mu/user/setting`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//회원 설정
export const requestUserSettingUpdate = (params) =>
  axios
    .post(`${urls}/mu/user/setting/update`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
